/**
 * Project workspace tab bar — icons, ids, and labels (single source of truth).
 */
import {
  RiDashboardLine,
  RiBugLine,
  RiLayoutGridLine,
  RiListCheck,
  RiSettingsLine,
} from "react-icons/ri";

export const PROJECT_TAB_NAV_ITEMS = [
  { id: "dashboard", icon: RiDashboardLine, label: "Project Dashboard" },
  { id: "issues", icon: RiBugLine, label: "Work Items" },
  { id: "boards", icon: RiLayoutGridLine, label: "Kanban board" },
  { id: "backlog", icon: RiListCheck, label: "Backlog" },
  { id: "settings", icon: RiSettingsLine, label: "Project Settings" },
];
